export function getFullNameInitials(fullName: string): string {
  try {
    return fullName
      .split(' ')
      .slice(0, 2)
      .map(word => word[0])
      .join(',')
      .replace(',', '');
  } catch {
    return '';
  }
}
